import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyPhoneBar from './components/StickyPhoneBar';
import FloatingCTA from './components/FloatingCTA';

// Pages
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AreasHubPage from './pages/AreasHubPage';
import AreaDetailPage from './pages/AreaDetailPage';
import LocalSeoDetailPage from './pages/LocalSeoDetailPage';
import AboutPage from './pages/AboutPage';
import ReferencesPage from './pages/ReferencesPage';
import ContactPage from './pages/ContactPage';
import ThankYouPage from './pages/ThankYouPage';
import EnglishPage from './pages/EnglishPage';
import DeutschPage from './pages/DeutschPage';
import SitemapPage from './pages/SitemapPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-[#fcfbf7] text-[#1c2620]">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          {/* Main Core Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/omraader" element={<AreasHubPage />} />
          <Route path="/om-os" element={<AboutPage />} />
          <Route path="/referencer" element={<ReferencesPage />} />
          <Route path="/galleri" element={<ReferencesPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/tak" element={<ThankYouPage />} />
          <Route path="/english" element={<EnglishPage />} />
          <Route path="/deutsch" element={<DeutschPage />} />
          <Route path="/sitemap" element={<SitemapPage />} />

          {/* Core Services (original URLs preserved) */}
          <Route path="/traefaeldning" element={<ServiceDetailPage forcedSlug="traefaeldning" />} />
          <Route path="/topkapning" element={<ServiceDetailPage forcedSlug="topkapning" />} />
          <Route path="/stubfraesning" element={<ServiceDetailPage forcedSlug="stubfraesning" />} />
          <Route path="/rodfraesning" element={<ServiceDetailPage forcedSlug="stubfraesning" />} />
          <Route path="/beskaering-af-traeer" element={<ServiceDetailPage forcedSlug="beskaering-af-traeer" />} />
          <Route path="/beskaering" element={<ServiceDetailPage forcedSlug="beskaering-af-traeer" />} />
          <Route path="/anlaeg" element={<ServiceDetailPage forcedSlug="anlaeg" />} />
          <Route path="/haekklipning" element={<ServiceDetailPage forcedSlug="haekklipning" />} />
          <Route path="/alm-skovning" element={<ServiceDetailPage forcedSlug="alm-skovning" />} />
          <Route path="/ydelser/:slug" element={<ServiceDetailPage />} />

          {/* Primary Areas / City Pages (original URLs preserved) */}
          <Route path="/kolding" element={<AreaDetailPage forcedSlug="kolding" />} />
          <Route path="/fredericia" element={<AreaDetailPage forcedSlug="fredericia" />} />
          <Route path="/vejle" element={<AreaDetailPage forcedSlug="vejle" />} />
          <Route path="/horsens" element={<AreaDetailPage forcedSlug="horsens" />} />
          <Route path="/skanderborg" element={<AreaDetailPage forcedSlug="skanderborg" />} />
          <Route path="/aarhus" element={<AreaDetailPage forcedSlug="aarhus" />} />
          <Route path="/omraader/:slug" element={<AreaDetailPage />} />

          {/* All 18 Specific Local SEO Landing Pages (original URLs preserved) */}
          {/* Kolding */}
          <Route path="/traefaeldning-i-kolding" element={<LocalSeoDetailPage forcedSlug="traefaeldning-i-kolding" />} />
          <Route path="/topkapning-kolding" element={<LocalSeoDetailPage forcedSlug="topkapning-kolding" />} />
          <Route path="/rodfraesning-i-kolding" element={<LocalSeoDetailPage forcedSlug="rodfraesning-i-kolding" />} />

          {/* Fredericia */}
          <Route path="/traefaeldning-i-fredericia" element={<LocalSeoDetailPage forcedSlug="traefaeldning-i-fredericia" />} />
          <Route path="/topkapning-fredericia" element={<LocalSeoDetailPage forcedSlug="topkapning-fredericia" />} />
          <Route path="/rodfraesning-i-fredericia" element={<LocalSeoDetailPage forcedSlug="rodfraesning-i-fredericia" />} />

          {/* Vejle */}
          <Route path="/traefaeldning-i-vejle" element={<LocalSeoDetailPage forcedSlug="traefaeldning-i-vejle" />} />
          <Route path="/topkapning-vejle" element={<LocalSeoDetailPage forcedSlug="topkapning-vejle" />} />
          <Route path="/rodfraesning-i-vejle" element={<LocalSeoDetailPage forcedSlug="rodfraesning-i-vejle" />} />

          {/* Horsens */}
          <Route path="/traefaeldning-i-horsens" element={<LocalSeoDetailPage forcedSlug="traefaeldning-i-horsens" />} />
          <Route path="/topkapning-horsens" element={<LocalSeoDetailPage forcedSlug="topkapning-horsens" />} />
          <Route path="/rodfraesning-i-horsens" element={<LocalSeoDetailPage forcedSlug="rodfraesning-i-horsens" />} />

          {/* Skanderborg */}
          <Route path="/traefaeldning-i-skanderborg" element={<LocalSeoDetailPage forcedSlug="traefaeldning-i-skanderborg" />} />
          <Route path="/topkapning-skanderborg" element={<LocalSeoDetailPage forcedSlug="topkapning-skanderborg" />} />
          <Route path="/rodfraesning-i-skanderborg" element={<LocalSeoDetailPage forcedSlug="rodfraesning-i-skanderborg" />} />

          {/* Aarhus */}
          <Route path="/traefaeldning-i-aarhus" element={<LocalSeoDetailPage forcedSlug="traefaeldning-i-aarhus" />} />
          <Route path="/topkapning-aarhus" element={<LocalSeoDetailPage forcedSlug="topkapning-aarhus" />} />
          <Route path="/rodfraesning-aarhus" element={<LocalSeoDetailPage forcedSlug="rodfraesning-aarhus" />} />

          {/* 403 & 404 Pages */}
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingCTA />
      <StickyPhoneBar />
    </div>
  );
}
